document.addEventListener('DOMContentLoaded', () => {
  const menuButtons = document.querySelectorAll('[aria-controls=site-nav]');
  const pages = document.querySelectorAll('.site-nav__pages > li');
  const childPages = document.querySelectorAll('.site-nav__child-link');
  const nav = document.querySelector('.site-nav');
  const header = document.querySelector('.site-header');
  const topBar = document.querySelector('.site-top-bar');
  const searchButton = document.querySelector('[aria-controls=nav-search]');
  const searchForm = document.querySelector('#nav-search-form');
  const main = document.querySelector('#main');
  const bg = document.querySelector('.site-nav__bg');
  const menuDelayCap = 70;
  const menuInDelayCap = 70;
  const menuOutDelayCap = 100;
  let menuInterval = null;
  let menuDelay = 0;
  let menuActive = false;

  const navDelayCap = 1;
  const navInDelayCap = 1;
  const navOutDelayCap = 100;
  const navInterval = null;
  const navDelay = 0;
  const navActive = false;

  function devLog(msg) {
    // console.log(msg);
  }

  function isTouchDevice() {
    return Boolean(
      'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
    );
  }

  menuButtons.forEach((menuButton) => {
    menuButton.addEventListener('click', () => {
      // main.classList.remove('is-search-open');
      // main.classList.toggle('is-nav-open');
      if (isMenuOpen()) {
        main.classList.remove('is-nav-open');
      } else if (main.classList.contains('is-search-open')) {
        main.classList.remove('is-search-open');
      } else {
        main.classList.add('is-nav-open');
      }
    });
  });

  function isMenuOpen() {
    return main.classList.contains('is-nav-open') === true;
  }

  // When the escape key is pressed, close the menu.
  document.addEventListener('keydown', (e) => {
    if (isMenuOpen() && e.key === 'Escape') {
      main.classList.remove('is-nav-open');
      nav.classList.remove('is-expanded');
      pages.forEach((page) => {
        const active = false;
        if (page.hasAttribute('aria-expanded')) {
          page.setAttribute('aria-expanded', String(active));
          page
            .querySelector(':scope > .site-nav__section')
            .setAttribute('aria-hidden', String(!active));
          page.querySelector(':scope > .site-nav__section').hidden = !active;
        }
      });
      clearInterval(menuInterval);
      menuDelay = 0;
    }
  });

  // if (searchButton) {
  //   console.log('searchButton', searchButton);
  //   searchButton.addEventListener('click', (e) => {
  //     const active = true;
  //     console.log('searchButton click');
  //     main.classList.add('is-nav-open');
  //     main.classList.add('is-search-open');
  //     // searchButton.setAttribute('aria-expanded', String(active));
  //     // searchButton.setAttribute('aria-hidden', String(active));
  //     // searchButton.hidden = active;
  //     // searchForm.setAttribute('aria-expanded', String(active));
  //     // searchForm.setAttribute('aria-hidden', String(!active));
  //     // searchForm.hidden = !active;
  //     // searchForm.querySelector('input').focus();
  //     e.preventDefault();
  //     return false;
  //   });
  // }

  pages.forEach((el) => {
    const resizeSection = () => {
      if (!el.querySelector(':scope > .site-nav__section')) return false;
      let height = el.querySelector(':scope > .site-nav__section').offsetHeight;

      // check height of all subsections
      const maxHeight = height;
      const containerEl = el.querySelector(
        ':scope > .site-nav__section > .container'
      );
      const containerPaddingTop = containerEl
        ? parseFloat(getComputedStyle(containerEl).paddingTop) || 0
        : 0;
      el.querySelectorAll('.site-mega-menu__links').forEach((sub) => {
        const subHeight =
          sub.offsetHeight + containerPaddingTop + containerPaddingTop;
        if (subHeight > maxHeight) height = subHeight;
      });

      // if (header) height += header.offsetHeight;
      if (topBar && topBar.offsetHeight) height += topBar.offsetHeight;
      if (topBar && !topBar.hidden) height += topBar.offsetHeight;
      if (height < 300) height = 300;
      el.querySelector(':scope > .site-nav__section').style.height =
        height + 'px';
    };

    resizeSection();

    const resizeBg = () => {
      let height = el.querySelector(':scope > .site-nav__section').offsetHeight;

      // check height of all subsections
      const maxHeight = height;
      const containerEl = el.querySelector(
        ':scope > .site-nav__section > .container'
      );
      const containerPaddingTop = containerEl
        ? parseFloat(getComputedStyle(containerEl).paddingTop) || 0
        : 0;
      el.querySelectorAll('.site-mega-menu__links').forEach((sub) => {
        const subHeight =
          sub.offsetHeight + containerPaddingTop + containerPaddingTop;
        console.log('subHeight', sub.offsetHeight);
        if (subHeight > maxHeight) height = subHeight;
      });

      if (header) height += header.offsetHeight;
      if (topBar && topBar.offsetHeight) height += topBar.offsetHeight;
      if (topBar && !topBar.hidden) height += topBar.offsetHeight;
      if (height < 300) height = 300;
      bg.style.height = height + 'px';
    };

    const toggle = (e) => {
      clearInterval(menuInterval);
      menuDelay = 0;

      const active = !(
        e.target.closest('.site-nav__li').getAttribute('aria-expanded') ===
        'true'
      );
      el.setAttribute('aria-expanded', String(active));
      el.querySelector(':scope > .site-nav__section').setAttribute(
        'aria-hidden',
        String(!active)
      );
      el.querySelector(':scope > .site-nav__section').hidden = !active;
      if (active) main.classList.add('is-nav-expanded');
      else main.classList.remove('is-nav-expanded');

      e.preventDefault();
      return false;
    };

    const toggleViaBtn = (e) => {
      clearInterval(menuInterval);
      menuDelay = 0;
      devLog('toggleViaBtn');
      if (
        e.target.closest('.site-nav').getAttribute('aria-expanded') === 'true'
      ) {
        contract();
        devLog('contract');
      } else {
        expand();
        devLog('expand');
      }
      e.preventDefault();
      return false;
    };

    const contract = () => {
      main.classList.remove('is-nav-open');
      main.classList.remove('is-nav-expanded');
      nav.classList.remove('is-expanded');

      pages.forEach((page) => {
        const active = false;
        if (page.hasAttribute('aria-expanded')) {
          page.setAttribute('aria-expanded', String(active));
          page
            .querySelector(':scope > .site-nav__section')
            .setAttribute('aria-hidden', String(!active));
          page.querySelector(':scope > .site-nav__section').hidden = !active;

          page
            .querySelector(':scope > .site-nav__section')
            .classList.remove('is-visible');
        }
      });

      if (searchButton) {
        searchButton.setAttribute('aria-expanded', String(false));
        if (el.hasAttribute('aria-expanded')) {
          el.setAttribute('aria-expanded', false);
          el.querySelector(':scope > .site-nav__section').setAttribute(
            'aria-hidden',
            true
          );
          el.querySelector(':scope > .site-nav__section').hidden = true;
        }
      }
    };

    const expand = () => {
      devLog('expand');
      clearInterval(menuInterval);
      menuDelay = 0;

      main.classList.add('is-nav-open');
      devLog('is-nav-open');
      main.classList.add('is-nav-expanded');
      nav.classList.add('is-expanded');

      pages.forEach((page) => {
        const active = page === el;
        if (page.hasAttribute('aria-expanded')) {
          page.setAttribute('aria-expanded', String(active));
          page
            .querySelector(':scope > .site-nav__section')
            .setAttribute('aria-hidden', String(!active));
          page.querySelector(':scope > .site-nav__section').hidden = !active;

          if (active) {
            setTimeout(() => {
              page
                .querySelector(':scope > .site-nav__section')
                .classList.add('is-visible');
            }, 1);
          }
        }
      });

      resizeBg();
    };

    const hoverIf = (condition, e) => {
      devLog('hoverIf');
      if (condition(e)) {
        expandDelay(e);
      }
    };

    const leaveA = () => {
      clearInterval(menuInterval);
      menuDelay = 0;
    };

    const leave = () => {
      clearInterval(menuInterval);
      menuDelay = 0;
    };

    const expandDelay = (e) => {
      clearInterval(menuInterval);
      menuDelay = isMenuOpen() ? menuDelayCap : menuInDelayCap;
      menuInterval = setInterval(() => {
        if (menuDelay > 0) {
          menuDelay -= 1;
          if (menuDelay <= 0) {
            if (e.target.parentNode.hasAttribute('aria-expanded')) {
              expand();
            } else {
              contract();
            }
          }
        }
      }, 1);
    };

    const expandIf = (condition, e) => {
      if (condition(e)) {
        devLog('toggle');
        toggle(e);
      }
    };

    const expandHoverIf = (condition, e) => {
      if (condition(e) && (menuDelay <= 0 || !isMenuOpen())) {
        if (e.target.parentNode.hasAttribute('aria-expanded')) {
          expandDelay(e);
        } else {
          contract();
        }
        e.preventDefault();
      }
    };

    const contractIf = (condition, e) => {
      if (condition(e)) {
        clearInterval(menuInterval);
        menuDelay = menuOutDelayCap;
        menuInterval = setInterval(() => {
          if (menuDelay > 0) {
            menuDelay -= 1;
            if (menuDelay <= 0 && !menuActive) {
              devLog(menuActive);
              devLog('contracted');
              contract();
              e.preventDefault();
            }
          }
        }, 1);
      }
    };

    const bgEnter = () => {
      devLog('bgEnter');
      menuActive = true;
    };

    const bgLeave = () => {
      devLog('bgLeave');
      menuActive = false;
    };

    const expandIfMobile = expandIf.bind(undefined, (e) => {
      return (
        window.matchMedia('(max-width: 1400px)').matches &&
        e.target.closest('.site-nav__li').hasAttribute('aria-expanded')
      );
    });

    const hoverIfDesktop = hoverIf.bind(undefined, (e) => {
      return window.matchMedia('(min-width: 1400px)').matches;
    });

    const expandHoverIfDesktop = expandHoverIf.bind(undefined, (e) => {
      return window.matchMedia('(min-width: 1400px)').matches;
    });

    const contractIfDesktop = contractIf.bind(undefined, (e) => {
      return window.matchMedia('(min-width: 1400px)').matches;
    });

    const back = el.querySelector('.site-nav__back');
    if (back) {
      back.addEventListener('click', () => {
        main.classList.remove('is-nav-expanded');
        nav.classList.remove('is-expanded');
        el.setAttribute('aria-expanded', 'false');
        el.querySelector('.site-nav__section').setAttribute(
          'aria-hidden',
          String(true)
        );
        el.querySelector('.site-nav__section').hidden = true;
      });
    }

    const closeButton = el.querySelector('.site-nav__close');
    if (closeButton) {
      closeButton.addEventListener('click', contract);
    }

    // const toggleButton = el.querySelector('.site-nav__link-toggle');
    // if (toggleButton) {
    //   toggleButton.addEventListener('click', toggleViaBtn);
    // }

    const a = el.querySelector('.site-nav__link');
    a.addEventListener('click', expandIfMobile);
    a.addEventListener('mouseleave', leaveA);
    nav.addEventListener('mouseleave', leave);

    bg.addEventListener('mouseenter', bgEnter);
    bg.addEventListener('mouseleave', bgLeave);

    a.addEventListener('mouseenter', hoverIfDesktop);
    a.addEventListener('mouseenter', expandHoverIfDesktop);
    nav.addEventListener('mouseleave', contractIfDesktop);

    contract();

    if (el.dataset.id === 'search') {
      searchButton.addEventListener('click', (e) => {
        expand();
        searchForm.querySelector('input').focus();
        // const active = true;
        // console.log('searchButton click');
        // main.classList.add('is-nav-open');
        // main.classList.add('is-search-open');
        // searchButton.setAttribute('aria-expanded', String(active));
        // searchButton.setAttribute('aria-hidden', String(active));
        // searchButton.hidden = active;
        // searchForm.setAttribute('aria-expanded', String(active));
        // searchForm.setAttribute('aria-hidden', String(!active));
        // searchForm.hidden = !active;
        // searchForm.querySelector('input').focus();
        e.preventDefault();
        return false;
      });
    }
  });

  // childPages.forEach((el) => {
  //   const section = el.closest('.site-nav__section, .site-nav__subsection');

  //   const onClick = (e) => {
  //     console.log('child onClick');

  //     clearInterval(navInterval);
  //     navDelay = navDelayCap;
  //     navInterval = setInterval(() => {
  //       if (navDelay > 0) {
  //         navDelay -= 1;
  //         if (navDelay <= 0) {
  //           clearInterval(navInterval);
  //           navDelay = 0;
  //           const id = el.dataset.id || el.getAttribute('data-id');
  //           console.log('show subsection', id);
  //           hideAllSubsections();
  //           showSubsection(id);
  //         }
  //       }
  //     }, 1);

  //     e.preventDefault();
  //     return false;
  //   };

  //   const onLeave = () => {
  //     clearInterval(navInterval);
  //     navDelay = 0;
  //     hideAllSubsections();
  //     showDefaultSubsections();
  //   };

  //   const showSubsection = (id) => {
  //     // show subsection
  //     const subsection = el.querySelector(
  //       `.site-nav__subsection[data-id="${id}"]`
  //     );
  //     if (subsection) {
  //       subsection.setAttribute('aria-hidden', 'false');
  //       subsection.hidden = false;
  //     }

  //     // activate links
  //     document
  //       .querySelectorAll(`.site-nav__child-link[data-id="${id}"]`)
  //       .forEach((link) => {
  //         if (link.hasAttribute('aria-expanded')) {
  //           link.setAttribute('aria-expanded', 'true');
  //         }
  //       });
  //   };

  //   const hideSubsection = (id) => {
  //     // hide subsection
  //     const subsection = document.querySelector(
  //       `.site-nav__subsection[data-id="${id}"]`
  //     );
  //     if (subsection) {
  //       subsection.setAttribute('aria-hidden', 'true');
  //       subsection.hidden = true;
  //     }

  //     // deactivate links
  //     document
  //       .querySelectorAll(`.site-nav__child-link[data-id="${id}"]`)
  //       .forEach((link) => {
  //         if (link.hasAttribute('aria-expanded')) {
  //           link.setAttribute('aria-expanded', 'false');
  //         }
  //       });
  //   };

  //   const hideAllSubsections = () => {
  //     const subsections = document.querySelectorAll('.site-nav__subsection');
  //     subsections.forEach((sub) => {
  //       hideSubsection(sub.dataset.id || sub.getAttribute('data-id'));
  //     });
  //   };

  //   // const showDefaultSubsections = () => {
  //   //   const defaultLinks = document.querySelectorAll(
  //   //     '.site-nav__child-link[data-default]'
  //   //   );
  //   //   defaultLinks.forEach((link) => {
  //   //     showSubsection(link.dataset.id || link.getAttribute('data-id'));
  //   //   });
  //   // };

  //   el.addEventListener('click', onClick);
  //   // nav.addEventListener('mouseleave', onLeave);

  //   // hideAllSubsections();
  //   // showDefaultSubsections();
  // });

  // // detect current sections and pages
  // if (typeof setCurrentPage !== 'undefined' && setCurrentPage) {
  //   const link = document.querySelector(
  //     '.site-nav__child-link[data-id="' + setCurrentPage + '"]'
  //   );
  //   if (link) {
  //     link.classList.add('site-nav__child-link--active');
  //   }
  // }

  // if (typeof setCurrentSection !== 'undefined' && setCurrentSection) {
  //   // const section = document.querySelector(
  //   //   '.site-nav__li[data-id="' + setCurrentSection + '"]'
  //   // );
  //   // const active = true;
  //   // if (section && !isTouchDevice()) {
  //   //   section.setAttribute('aria-expanded', String(active));
  //   //   section
  //   //     .querySelector(':scope > .site-nav__section')
  //   //     .setAttribute('aria-hidden', String(!active));
  //   //   section.querySelector(':scope > .site-nav__section').hidden = !active;
  //   // }
  //   const link = document.querySelector(
  //     '.site-nav__link[data-id="' + setCurrentSection + '"]'
  //   );
  //   if (link) {
  //     link.classList.add('site-nav__link--active');
  //   }
  // }
});
